import {AssemblyScreen} from "./AssemblyScreen";
import {MovieSlot} from "../GameObjects/Assembly/MovieModel";
import {AssemblyModel} from "../GameObjects/Assembly/AssemblyModel";
import {Button} from "../GameObjects/Button";
import {Ease} from "../Core/Animatable";
import {Movie} from "../GameObjects/Assembly/Movie";
import {Sprite} from "../Core/Sprite";
import {Callback, Dict} from "../Core/Reflection";
import {Keyboard} from "../GameObjects/Keyboard";
import {playVO, ReactionVO, stopVO} from "../Data/VoiceOver";

export class MovieScreen extends AssemblyScreen<MovieSlot> {

    public readonly tvBg = this.main.addChild(new Sprite());
    public readonly tv = this.main.addChild(new Movie());
    public readonly camera = this.main.addChild(new Sprite());
    public readonly buttonBack = this.main.addChild(new Button());
    public readonly buttonPlay = this.main.addChild(new Button());

    init(pSize: PIXI.Point, model: AssemblyModel<MovieSlot>) {
        super.init(pSize, model);

        this.buttonBack.visible = false;
        this.buttonPlay.visible = false;

        this.buttonBack.clickSfx = "ui_select";
        this.buttonBack.hoverVO = "patw_ui15";
        this.buttonBack.onClick.add(() => {
            this.buttonBack.enabled = false;
            this.buttonPlay.enabled = false;
            this.superReturnHome(model, true);
        });
        this.buttonPlay.hoverVO = "LetsGoLuna_016";
        this.buttonPlay.onClick.add(() => {
            this._factsDisabled = false;
            this.clearKeyboard();
            this.hideMovieButtons(() => this.hideTV(() => this.showEditButtons()));
        });
        this.tv.visible = false;
        this.tvBg.visible = false;
    }

    protected getStartVO(): (string | number)[] | undefined {
        return [
            ...ReactionVO(),
            "LetsGoLuna_092", 0.5,
            "LetsGoLuna_093", 0.5,
            "LetsGoLuna_097"
        ];
    }

    protected getSlotHoverVO(): Dict<MovieSlot, string> | undefined {
        return {
            [MovieSlot.Background]: "LetsGoLuna_094",
            [MovieSlot.Character]: "LetsGoLuna_095",
            [MovieSlot.Prop]: "LetsGoLuna_096",
        };
    }

    protected getAssemblyCompleteVO(): string[] | undefined {
        return [
            "LetsGoLuna_099",
            "LetsGoLuna_100",
            "LetsGoLuna_101",
            "LetsGoLuna_102"
        ];
    }

    protected getFactVO(): string[] | undefined {
        return [
            "LetsGoLuna_103",
            "LetsGoLuna_104"
        ];
    }

    protected returnHome(model: AssemblyModel<MovieSlot>, submitted: boolean) {
        if (submitted) {
            this.clearKeyboard();
            this.hideEditButtons(() => {
                this.showTV(() => {
                    this._factsDisabled = false;
                    stopVO();
                    playVO("LetsGoLuna_098", () => {
                        this.tv.showAnimal(() => {
                            this.playCompleteVO();
                            this.showMovieButtons();
                        });
                    });
                });
            });
        } else {
            this.superReturnHome(model, submitted);
        }
    }

    private superReturnHome(model: AssemblyModel<MovieSlot>, submitted: boolean) {
        super.returnHome(model, submitted);
    }

    private showTV(cb?: Callback) {
        const y = this.camera.y;
        this.camera.moveYTo(this._size.y + this.camera.height * 0.5, 0.2, Ease.sineIn, () => {
            this.camera.y = y;
            this.camera.visible = false;
        });
        this.tv.visible = true;
        this.tv.setModel(this.assembly.getModel());
        this.tv.asTV();
        this.tv.tweenFrom(0.4, Ease.sineOut, {
            y: -this._size.y - this.tv.height * 0.5,
            scaleX: this.assembly.scale.x,
            scaleY: this.assembly.scale.y,
            onComplete: () => {
                this.tvBg.visible = true;
                this.tvBg.alphaFrom(0, 0.2, cb);
            }
        });
        this.buttonHome.enabled = false;
    }

    private hideTV(cb?: Callback) {
        const y = this.tv.y;
        this.tv.moveYTo(-this._size.y - this.tv.height * 0.5, 0.2, Ease.sineIn, () => {
            this.tv.y = y;
            this.tv.visible = false;
        });
        this.tvBg.alphaTo(0, 0.2, () => {
            this.tvBg.visible = false;
            this.tvBg.alpha = 1;
            this.camera.visible = true;
            this.camera.moveYFrom(this._size.y + this.camera.height * 0.5, 0.4, Ease.sineOut, cb);
            this.buttonHome.enabled = true;
        });
        this.stopActivityCompleteIdle();
    }

    private hideEditButtons(cb?: Callback) {
        this.hideButtons([...this.buttons, this.buttonOk], cb);
    }

    private showEditButtons(cb?: Callback) {
        this.showButtons([...this.buttons, this.buttonOk], cb);
        this.initKeyboard();
    }

    private hideMovieButtons(cb?: Callback) {
        this.hideButtons([this.buttonBack, this.buttonPlay], cb);
    }

    private showMovieButtons(cb?: Callback) {
        this.tvKeyboard();
        this.showButtons([this.buttonBack, this.buttonPlay], cb);
        this.startActivityCompleteIdle();
    }

    private tvKeyboard() {
        Keyboard.clear();
        Keyboard.add(
            this.buttonPlay,
            this.buttonBack,
            this.buttonMute
        );
    }

    startActivityCompleteIdle() {
        if (this.tv.visible) {
            super.startActivityCompleteIdle();
        }
    }
}